import { useEffect, useRef, useState } from 'react';

export function useVisibilityObserver(elementRef: React.RefObject<HTMLElement | null>) {
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (hasBeenVisible) return;

    const element = elementRef.current;
    if (!element) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setHasBeenVisible(true);
          observerRef.current?.disconnect();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '200px 0px 200px 0px',
      },
    );

    observerRef.current.observe(element);

    return () => {
      observerRef.current?.disconnect();
    };
  }, [elementRef, hasBeenVisible]);

  return hasBeenVisible;
}
